export default __webpack_public_path__ + "static/media/delivery-truck.1f351295.svg";